"use client";

import { useRouter } from "next/navigation";
import { useTransition } from "react";

const COOKIE_NAME = "vault88-owner-banner-hidden";

function setHiddenCookie(hidden: boolean) {
  const maxAge = hidden ? 60 * 60 * 24 * 7 : 0; // 7 days
  document.cookie = `${COOKIE_NAME}=${hidden ? "1" : ""}; Path=/; Max-Age=${maxAge}; SameSite=Lax${
    location.protocol === "https:" ? "; Secure" : ""
  }`;
}

export function OwnerBannerHideButton() {
  const router = useRouter();
  const [pending, startTransition] = useTransition();

  return (
    <button
      type="button"
      onClick={() => {
        setHiddenCookie(true);
        startTransition(() => router.refresh());
      }}
      disabled={pending}
      className="rounded-sm border border-white/40 px-2 py-1 text-[10px] font-semibold uppercase tracking-[0.2em] transition hover:bg-white hover:text-slate-900 disabled:opacity-60 sm:px-3 sm:tracking-[0.3em]"
      title="Hide this bar (visible only on this device)"
    >
      Hide
    </button>
  );
}

export function OwnerBannerShowPill() {
  const router = useRouter();
  const [pending, startTransition] = useTransition();

  return (
    <button
      type="button"
      onClick={() => {
        setHiddenCookie(false);
        startTransition(() => router.refresh());
      }}
      disabled={pending}
      className="fixed top-2 right-2 z-30 rounded-full bg-slate-900/90 px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.3em] text-white shadow-lg transition hover:bg-slate-900 disabled:opacity-60"
      title="Show owner view bar"
    >
      Owner
    </button>
  );
}
